import { render, staticRenderFns } from "./IndexQueryData.vue?vue&type=template&id=1cf60e7c"
import script from "./IndexQueryData.vue?vue&type=script&lang=js"
export * from "./IndexQueryData.vue?vue&type=script&lang=js"
import style0 from "./IndexQueryData.vue?vue&type=style&index=0&id=1cf60e7c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports